import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AddassettypepopupComponent } from '../addassettypepopup/addassettypepopup.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
@Component({
  selector: 'app-addassetpopup',
  templateUrl: './addassetpopup.component.html',
  styleUrls: ['./addassetpopup.component.css']
})
export class AddassetpopupComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  @ViewChild('documentbar', { static: false }) documentbar;

  formname: string = "Asset";
  trxtype: string = "ASSET";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  assettypeColl: any = [];
  assetColl: any = [];
  assetBO: any = {};
  assetid: number = 0

  historyassetColl: any = [];

  assetform = new FormGroup({
    assetid: new FormControl(0),
    assetno: new FormControl('', Validators.required),
    assetname: new FormControl('', Validators.required),
    assettypeid: new FormControl(null, Validators.required),
    assetvalue: new FormControl(null),
    remarks: new FormControl(''),
    brandname: new FormControl(''),
    model: new FormControl(''),
    serialno: new FormControl(''),
    warrantydt: new FormControl(null, Validators.required),
    purchasedt: new FormControl(null, Validators.required),
    invoiceno: new FormControl(''),
    assetcurrentvalue: new FormControl(null),
    locationname: new FormControl(''),
    descr: new FormControl(''),
    inactive: new FormControl(false),
  });

  @Output() emitData = new EventEmitter();

  dateCustomClasses: DatepickerDateCustomClasses[];
  
  constructor(private appService: AppdataService, public loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal, private datePipe: DatePipe,
    private productFindService: NgbModal,) {

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
    
  }
    


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.assetform.reset();
      this.fnInitializeFormGroup();
     this.fngetAssetType();
     
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.assetid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit() {
    //this.firstipcontrol.first.nativeElement.focus();
  }
  fnInitializeFormGroup() {
    this.assetform.setValue({
      assetid: 0,
      assetno: '',
      assetname: '',
      brandname: '',
      model: '',
      serialno: '',
      warrantydt: null,
      purchasedt:null,
      invoiceno: '',
      assetcurrentvalue:null,
      locationname: '',
      assettypeid: null,
      assetvalue: null,
      remarks: '',
      descr: '',
      inactive: false
    })
  }


  fngetAssetType() {
   
    var data = {
      'assettypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getAssetType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.assettypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;        
    }
    
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.assetform.valid) {
        //Check
        this.saveloading = true;

        var data = {
          'assetid': this.assetid,
          'assetno': this.assetform.get('assetno').value,
          'assetname': this.assetform.get('assetname').value,
          'assettypeid': this.assetform.get('assettypeid').value,
          'brandname': this.assetform.get('brandname').value,
          'model': this.assetform.get('model').value,
          'serialno': this.assetform.get('serialno').value,
          'warrantydt': this.fnFormatDatetime(this.assetform.get('warrantydt').value),
          'purchasedt': this.fnFormatDatetime(this.assetform.get('purchasedt').value),
          'invoiceno': this.assetform.get('invoiceno').value,
          'assetcurrentvalue': this.assetform.get('assetcurrentvalue').value,
          'locationname': this.assetform.get('locationname').value,
          'assetvalue': this.assetform.get('assetvalue').value,
          'remarks': this.assetform.get('remarks').value,
          'descr': this.assetform.get('descr').value,
          'inactive': this.assetform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckAsset(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
               
           
                  //Insert 
                  this.fnInsertAsset(data);
     
              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;

                  this.assetform.controls['assetname'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertAsset(data) {

    this.appService.fnInsertAsset(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {

           
            console.log( res.json())
            this.toastr.success('', "The new Asset has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.assetname);
            var result = res.json().result;
            
            var assetid = 0;
            if (result.length > 0) {
              assetid = result[0].assetid
            }
            this.emitData.emit(assetid);
            this.activeModal.close(true);
  

          }  
          else {
            this.loginService.fnAPIError(res.json())
          }
        }
        (err) => {
          this.saveloading = false;        
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }
//AddAllowance
private fnAddAssetType() {

  const modalRef = this.productFindService.open(AddassettypepopupComponent, { size: <any>'xxl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetAssetType();

    if (receivedEntry > 0) {
      this.assetform.patchValue({ assettypeid: receivedEntry })
    }
  });

}
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }


}

